import { render, staticRenderFns } from "./DetailType41Export.vue?vue&type=template&id=6705f5f8&scoped=true&"
import script from "./DetailType41Export.vue?vue&type=script&lang=js&"
export * from "./DetailType41Export.vue?vue&type=script&lang=js&"
import style0 from "./DetailType41Export.vue?vue&type=style&index=0&id=6705f5f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6705f5f8",
  null
  
)

export default component.exports